// Add [data-notab] to any html element you don't want to be tabbable
import Dom from '../utility/dom';

const Modal = {
    open: function(target){
        for (let element of Dom.focusable) {
            element.setAttribute('tabindex', '-1');
            if(!element.hasAttribute('data-notab') && (element.closest('.modal') == target || target.contains(element)) ){
                element.setAttribute('tabindex', '1');
            }
        }
    },
    close: function(target){
        for (let element of Dom.focusable) {
            // if(element.closest(['aria-hidden="true"'])){
            //     console.log(element);
            // }

            if(element.hasAttribute('data-notab') 
            || element.closest('.modal') == target 
            || target.contains(element)
            || element.closest('[aria-hidden="true"]')){
                element.setAttribute('tabindex', '-1');
            }
            else {
                element.setAttribute('tabindex', '1');
            }
        }
    },
    setToFocusable: function(target){
        for(let element of Dom.focusable){
            if(target.contains(element)){
                element.setAttribute('tabindex', '1');
            }
        }
    }
}


export default Modal;
